import React from "react";
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';
import openSansRegular from '../fonts/OpenSans/OpenSans-Regular.ttf'
import openSansItalic from '../fonts/OpenSans/OpenSans-Italic.ttf'
import openSansBold from '../fonts/OpenSans/OpenSans-Bold.ttf'
import openSansBoldItalic from '../fonts/OpenSans/OpenSans-BoldItalic.ttf'
import { formatEventDateShort } from '../helpers/dateHelper';

Font.register({ family: 'OpenSans', fonts: [
  { src: openSansRegular },
  { src: openSansItalic, fontStyle: 'italic' },
  { src: openSansBold, fontWeight: 700 },
  { src: openSansBoldItalic, fontStyle: 'italic', fontWeight: 700 },
 ]});

const EventsReportPDF = (props) => {
  const { data = [], account_settings = {}, title = "Report", subtitle = "" } = props

  const styles = StyleSheet.create({
    page: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35
    },
    row: {
      display: "flex",
      flexDirection: 'row',
      borderBottom: "1px solid #e8e8e8",
      padding: 5
    },
    rowHeader: {
      display: "flex",
      flexDirection: 'row',
      borderBottom: "1px solid #e8e8e8",
      backgroundColor: "#F7F7F7",
      padding: 5
    },
    rowHeaderText: {
      fontSize: 7,
      fontFamily: "OpenSans",
      fontWeight: 700
    },
    col: {
      flex: 1
    },
    section: {
      marginBottom: 20
    },
    sectionHeader: {
      flexDirection: 'row',
      borderBottom: "3px solid #CCC",
      marginBottom: 10
    },
    sectionHeaderText: {
      flex: 1,
      fontSize: 12,
      fontFamily: "OpenSans",
      fontWeight: 700,
      paddingHorizontal: 5,
      paddingBottom: 5
    },
    sectionHeaderRightText: {
      flex: 1,
      fontSize: 8,
      fontFamily: "OpenSans",
      fontWeight: 500,
      paddingRight: 5,
      paddingTop: 5,
      color: "#777777",
      textAlign: 'right'
    },
    header: {
      marginBottom: 20
    },
    headerText: {
      fontSize: 12,
      fontFamily: "OpenSans",
      fontWeight: 700,
      textAlign: "center"
    },
    subtitle: {
      fontSize: 8,
      fontFamily: "OpenSans",
      textAlign: "center",
      color: "#777777",
    },
    emptyText: {
      fontSize: 8,
      fontFamily: "OpenSans",
      color: "#777777",
      paddingTop: 15,
      textAlign: 'center'
    },
    dataText: {
      fontSize: 8,
      fontFamily: "OpenSans"
    },
  });

  const renderData = () => {
    return data.map(x => (
      <View style={styles.section}>
        <View style={styles.sectionHeader}>
          <Text style={styles.sectionHeaderText}>{x.label}</Text>
          <Text style={styles.sectionHeaderRightText}>{x.events.length} {x.events.length == 1 ? "event" : "events"}</Text>
        </View>
          <View style={styles.rowHeader}>
            <View style={{ width: 100 }}>
              <Text style={styles.rowHeaderText}>EVENT DATE</Text>
            </View>
            <View style={{ width: 120 }}>
              <Text style={styles.rowHeaderText}>EVENT TYPE</Text>
            </View>
            <View style={styles.col}>
              <Text style={styles.rowHeaderText}>EVENT NAME</Text>
            </View>
          </View>
        { x.events.map(e => (
          <View style={styles.row}>
            <View style={{ width: 100 }}>
              <Text style={styles.dataText}>{formatEventDateShort(e.event_date, account_settings)}</Text>
            </View>
            <View style={{ width: 120 }}>
              <Text style={styles.dataText}>{e.event_type_name}</Text>
            </View>
            <View style={styles.col}>
              <Text style={styles.dataText}>{e.event_name}</Text>
            </View>
          </View>
        ))}
        { x.events.length == 0 && (
          <Text style={styles.emptyText}>No events</Text>
        )}
      </View>
    ))
  }

  const renderDocument = () => {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.header}>
            <Text style={styles.headerText}>{title}</Text>
            <Text style={styles.subtitle}>{subtitle}</Text>
          </View>
          { renderData() }
        </Page>
      </Document>
    )
  }

  return renderDocument()
}

export default EventsReportPDF;
